import {useMutation, useQuery, useQueryClient} from "react-query";
import {
    getAppointmentWithMemberPollItems,
    getUserAppointments,
    requestCreateAppointment
} from "../../api/AlfyApiClient";
import {QUERY_KEYS} from "../query-keys";
import {CreateAppointmentRequest} from "../../models/request/appointment";
import {useSetRecoilState} from "recoil";
import {fromCreatePageState} from "./createAppointmentAtom";

const STALE_TIME = {
    APPOINTMENT: 1000 * 60 * 5,
    USER_APPOINTMENTS: 1000 * 60 * 5,
}

export const useCreateAppointment = () => {
    const queryClient = useQueryClient()
    const setFromCreatePage = useSetRecoilState(fromCreatePageState);

    return useMutation(async (request: CreateAppointmentRequest) => {
        return await requestCreateAppointment(request.duration, request.timeType, request.reminder)
    }, {
        onSuccess: (data) => {
            setFromCreatePage(true)
            queryClient.invalidateQueries(QUERY_KEYS.USER_APPOINTMENTS)
        },
        onError: (error) => {
            console.error(error)
        }
    })
}

export const useFetchAppointmentWithPoll = (appointmentId: string) => {
    return useQuery([QUERY_KEYS.APPOINTMENT, appointmentId],
        async () => {
            return await getAppointmentWithMemberPollItems(appointmentId)
        },
        {
            enabled: appointmentId.length > 0,
            staleTime: STALE_TIME.APPOINTMENT
        })
}

export const useFetchUserAppointments = () => {
    return useQuery(QUERY_KEYS.USER_APPOINTMENTS,
        async () => {
            return await getUserAppointments()
        },
        {
            staleTime: STALE_TIME.USER_APPOINTMENTS
        })
}